import { colorVariants } from "@/constants";
import { BadgeProps } from "@/types";
import React from "react";
import { Sentry } from '@/helpers/sentry';

const Badge: React.FC<BadgeProps> = ({
  color,
  text,
  dataToolTipId,
  className = "",
  onClick,
  variant = "default"
}) => {
  const colorConfig = colorVariants[color];

  if (!colorConfig) {
    Sentry.captureMessage(`Badge: Unknown color "${color}". Falling back to gray.`, 'warning');
    return (
      <span
        data-tooltip-id={dataToolTipId}
        className={`inline-flex items-center rounded-md bg-gray-400/10 px-2 py-1 text-xs font-medium text-gray-400 ring-1 ring-inset ring-gray-400/20 ${className}`.trim()}
        onClick={onClick}
        role={onClick ? "button" : undefined}
        tabIndex={onClick ? 0 : undefined}
      >
        {text}
      </span>
    );
  }

  const baseClasses = "inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset";

  const variantClasses = variant === "outline-solid"
    ? `bg-transparent border ${colorConfig.text} ${colorConfig.ring}`
    : `${colorConfig.bg} ${colorConfig.text} ${colorConfig.ring}`;

  const interactiveClasses = onClick
    ? "cursor-pointer hover:opacity-80 transition-opacity duration-150"
    : "";

  return (
    <span
      data-tooltip-id={dataToolTipId}
      className={`${baseClasses} ${variantClasses} ${interactiveClasses} ${className}`.trim()}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      } : undefined}
    >
      {text}
    </span>
  );
};

export default Badge;